import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OpenAIClient, AzureKeyCredential } from "@azure/openai";
import Input from "../common/Input";

function AIM(props) {
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [userMessage, setUserMessage] = useState("");
  const [aiResponse, setAiResponse] = useState({});
  const aiEndpoint = "https://aim.openai.azure.com/";
  const aiModel = "aim4";

  useEffect(() => {
    if (!safyInfo?.user?.modules) {
      navigate("/");
    }

    if (safyInfo.user.modules.includes("Admin") !== true) {
      navigate("/");
    }
  });

  useEffect(() => {
    document.title = "SAFY Portal - Admin";
    return () => {
      document.title = "SAFY Portal";
    };
  }, []);

  // Use the SchemaLoader project to export your db schema and then paste the schema in the placeholder below
  var systemMessage = `You are a helpful, cheerful database assistant. 
   Use the following database schema when creating your answers:
 
   FormsySubmissions (SubmissionId, ContainerId, VersionId, ApplicationId, PrimaryObjectId, PrimaryObjectName, PrimaryObjectType, SecondaryObjectId, SecondaryObjectName, SecondaryObjectType, TertiaryObjectId, TertiaryObjectName, TertiaryObjectType, Related, Results, Compliancy)
 
   Use JSON_Value(Compliancy, '$.date') to extract the date from the Compliancy column and is in the format of mm/dd/yyyy
 
   PrimaryObjectName is Supervisee 
 
   SecondaryObjectName is Supervisor
 
   Where ContainerId is A51B13BE-6B02-EF11-8076-DC98408D5418 or E2DD0183-5809-EF11-8076-0050F21C653C
 
   Include column name headers in the query results.
 
   Always provide your answer in the JSON format below:
 { "summary": "your-summary", "query":  "your-query" }
 
   Output ONLY JSON.
   In the preceding JSON response, substitute "your-query" with Microsoft SQL Server Query to retrieve the requested data.
   In the preceding JSON response, substitute "your-summary" with a summary of the query.
   Always include all columns in the table.
   If the resulting query is non-executable, replace "your-query" with NA, but still substitute "your-query" with a summary of the query.
   Do not use MySQL syntax.`;

  const queryAI = async () => {
    const openai = new OpenAIClient(
      aiEndpoint,
      new AzureKeyCredential(process.env.REACT_APP_AIKEY)
    );
    setAiResponse({});
    const response = await openai.getChatCompletions(aiModel, [
      {
        role: "system",
        content: systemMessage,
      },
      { role: "user", content: userMessage },
    ]);
    console.log(response);
    setAiResponse(
      JSON.parse(
        response.choices[0].message.content
          .replaceAll("```json", "")
          .replaceAll("```", "")
      )
    );
  };

  return (
    <div>
      <Input
        name="userMessage"
        label="AI Query for Supervision Logs"
        onChange={(e) => setUserMessage(e.target.value)}
        value={userMessage}
      />
      <div className="btn btn-success" onClick={() => queryAI()}>
        Ask AI
      </div>
      {aiResponse && (
        <>
          <div className="h5 my-2">Summary</div>
          <div className="mb-4">{aiResponse.summary}</div>
          <div className="h5 mb-2">Query</div>
          <div className="fw-bold">{aiResponse.query}</div>
        </>
      )}
    </div>
  );
}

export default AIM;
